import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6.707 8.293a1 1 0 0 1 0 1.414l-1.292 1.293h10.756a3.001 3.001 0 1 1 0 2h-10.756l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.414 0l-3 -3a1 1 0 0 1 -.097 -.112l-.071 -.11l-.054 -.114l-.035 -.105l-.025 -.118l-.007 -.058l-.004 -.09l.003 -.075l.017 -.126l.03 -.111l.044 -.111l.052 -.098l.067 -.096l.08 -.09l3 -3a1 1 0 0 1 1.414 0","key":"svg-0"}]]

const IconArrowLeftCircleFilled = createReactComponent('filled', 'arrow-left-circle-filled', 'ArrowLeftCircleFilled', __iconNode);

export default IconArrowLeftCircleFilled;